module.exports = __webpack_public_path__ + "img/w71b.59d1f58d.jpg";